export enum DsFormsDateDefaultValuesEnum {
  NONE = '',
  DATE = '%DATE%',
}
